<!-- @format -->
<template>
    <div class="already-activated-popup">
        <div class="close-button" @click="closePopup"><s3-close-svg /></div>
        <h1>Ready To Go!</h1>
        <woli-already-activated-svg />
        <p>
            Good news—someone on your team has already updated the billing info and your account is
            now fully active! You’re all set to keep using GlassHive without interruption. Jump back
            in and keep the momentum going!
        </p>

        <app-button class="proceed-button" @click="closePopup">
            <span> Proceed to GlassHive </span>
            <l6-back-svg class="rotate" @click="closePopup" />
        </app-button>
    </div>
</template>

<script>
const WoliAlreadyActivatedSvg = () => import('@/components/svg/account/woli-already-activated-svg');
const AppButton = () => import('@/components/common/app-button');
const L6BackSvg = () => import('@/components/svg/grid/l6-back-svg');
const S3CloseSvg = () => import('@/components/svg/grid/s3-close-svg');

export default {
    components: {
        'woli-already-activated-svg': WoliAlreadyActivatedSvg,
        'l6-back-svg': L6BackSvg,
        'app-button': AppButton,
        's3-close-svg': S3CloseSvg,
    },

    props: {},

    data() {
        return {};
    },

    computed: {},

    created() {},

    methods: {
        closePopup() {
            this.$emit('close');
        },
    },
};
</script>

<style>
.already-activated-popup {
    padding: 40px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: relative;
    border-radius: 16px;
    width: 100%;
    height: 100%;
}

.already-activated-popup h1 {
    font-size: 30px;
    text-align: center;
    margin-bottom: 28px;
}

.already-activated-popup svg {
    margin: 0 auto 24px;
}

.already-activated-popup p {
    font-size: 22px;
    font-family: 'Nunito';
    padding-bottom: 42px;
    border-bottom: 2px solid #e9e9ef;
    margin-bottom: 24px;
    line-height: 32px;
    text-align: center;
}

.already-activated-popup .app-button.proceed-button {
    width: 192px;
    display: flex;
    align-items: center;
    padding: 12px 16px;
    font-size: 14px;
    margin: 0 auto;
}

.already-activated-popup .l6-back-svg.rotate {
    width: 16px;
    position: relative;
    top: -1px;
}

.already-activated-popup .l6-back-svg.rotate .a {
    fill: #ffffff;
}

.already-activated-popup .l6-back-svg.rotate {
    transform: rotate(180deg);
    margin: 0 0 0 10px;
    margin-bottom: 0px;
}

.already-activated-popup .close-button {
    position: absolute;
    top: 24px;
    right: 24px;
    cursor: pointer;
}

.already-activated-popup .close-button svg {
    width: 24px;
}
</style>
